import { render, staticRenderFns } from "./tabPayrollRequisition.vue?vue&type=template&id=12158f8f"
import script from "./tabPayrollRequisition.vue?vue&type=script&lang=ts"
export * from "./tabPayrollRequisition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports